import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  const add = (e) => {
    e.preventDefault();
    addItem(product);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
    >
      <Link
        to={`/product/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group block rounded-xl border border-line bg-sand overflow-hidden hover:shadow-xl hover:border-forest/20 hover:-translate-y-1 transition-[box-shadow,border-color,transform] duration-300"
      >
        <div className="relative aspect-[4/5] overflow-hidden bg-sand">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <span className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.18em] font-bold text-forest bg-bone/80 backdrop-blur px-3 py-1.5 rounded-full">
            {product.category}
          </span>
          <button
            data-testid={`quick-add-${product.slug}`}
            onClick={add}
            className="absolute bottom-3 right-3 w-11 h-11 rounded-full bg-forest text-[#14100F] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 hover:bg-forest-dark transition-[opacity,transform,background-color] duration-300"
            aria-label={`Add ${product.name}`}
          >
            <Plus className="w-5 h-5" strokeWidth={2} />
          </button>
        </div>
        <div className="p-5 bg-bone">
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="font-display text-xl text-ink leading-tight">{product.name}</h3>
            <span className="text-ink font-semibold whitespace-nowrap">${product.price.toFixed(0)}</span>
          </div>
          <p className="text-sm text-stone mt-1">{product.subtitle}</p>
        </div>
      </Link>
    </motion.div>
  );
}
